import React, { Fragment, useEffect, useState } from 'react'

import GridDesiger from './GridDesiger'
import { AppPageDesiger } from './AppPageDesiger/AppPageDesiger'

export interface PageHandlerProps {
	metadataId?: number
	type?: string
	application?: string
	id?: string
}
export const PageDesiger = (props: PageHandlerProps) => {
	const renderByType = ():any => {
		switch (props.type) {
			case 'appGrid':
				return <GridDesiger {...props} />
			case 'appPage':
				return <AppPageDesiger {...props} />
			default:
				return <Fragment />
		}
	}
	return <Fragment>{renderByType()}</Fragment>
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/PageDesiger.tsx